import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { geoFromIP } from 'utils/bolt/geo';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';

// including US and CA  as they need the cookies modal too
const gdprRegions = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se', 'gb', 'us', 'ca'];

class StaticButton extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <button type="button" {...props} />;
	}
}

export default class Footer extends BaseComp.default {
    async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		if (gdprRegions.includes(geo?.countryCode)) {
			this.setState({ gdprRegion: true });
		}
	}
    renderLinks(items, type) {
		const base = super.renderLinks(items, type);
		const usingTrustArc = accessNested(this.props, 'store.appData.options.trustArcCookieConsent.url');

		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		const underAge = ageGateEnabled && !isOfAge;
		const copy = accessNested(Store.get(), 'appData.copy.baseCopy');

		if (type !== 'link' || !usingTrustArc || underAge || !this.state.gdprRegion) {
			return base;
		}

		return [].concat(base, [
			<li class={s.linkWrapper}>
				<StaticButton
					class={s.linkLink}
					role="button"
					onClick={() => window.truste.eu.prefview()}
				>
					{copy.$COOKIES_TITLE || 'Cookies Preferences'}
				</StaticButton>
			</li>,
			<li class={s.linkWrapper}>
				<StaticButton
					class={s.linkLink}
					role="button"
					onClick={() => window.truste.eu.irmClickListener()}
				>
					{copy.$DO_NOT_SELL || 'Do Not Sell'}
				</StaticButton>
			</li>
		]);
	}
}